/**
 * @typedef {object} LastRoundHighsState
 * @property {object} roundData
 * @property {object} seasonData
 */

/**
 * @typedef {object} LastRoundHighsActions
 * @property {string} type
 * @property {any} payload
 */